var Highlights = function() {



	this.init = function() {

		this.equalizer();

		this.HighlightsSlider();

	}

	this.equalizer = function(){

		$(window).on('load', function() {

			if ($(window).width() > 767) {

				var height = $('.article .right').outerHeight();

				$('.article .img-holder').height(height);

			}

		});

	}

	$('[data-component="highlights"] .read-more').on('mouseenter', function(){
		$('.read-more i').attr('class', 'icon-arrow-right-black')
	}).on('mouseleave', function(){
		$('.read-more i').attr('class', 'icon-arrow-right')
	});

	this.HighlightsSlider = function(){

		$('[data-component="highlights"] .div-to-slide').slick({
			arrows: false,
			slidesToShow: 1,
			centerMode: true,
			centerPadding: '0px',
			responsive: [
				{
					breakpoint: 768,
					settings: {
						arrows: false,
						centerMode: true,
						centerPadding: '0px',
						infinite: false
					}
				}
			]
		});

		$('[data-component="highlights"] a[data-slide]').click(function(e) {
			e.preventDefault();
			var slideno = $(this).data('slide');
			$('[data-component="highlights"] .div-to-slide').slick('slickGoTo', slideno);
			$(this).siblings().removeClass("current");
			$(this).addClass("current");
		});

		$('.div-to-slide').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		  var slideNum = nextSlide;
		  $('[data-component="pagination"] a').each(function(){
		  	var currentData = $(this).data('slide');
		  	if(currentData == slideNum){
		  		$('[data-component="pagination"] a').removeClass('current');
		  		$(this).addClass('current');
		  	}
		  })
		});

	}

	return this.init();

}
